// @ helpers
const { APIGet } = require('utilities/APIRequestHelper');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');

// @ constants
const {
    CARD_DATA_SUCCESS,
    CARD_DATA_REQUEST,
    CARD_DATA_FAILURE,
} = require('constants/contactCenter/actionTypes');

const requestCardDataRequest = () => ({
    type: CARD_DATA_REQUEST
});

const requestCardDataSuccess = payload => ({
    type: CARD_DATA_SUCCESS,
    payload
});

const requestCardDataFailure = error => ({
    type: CARD_DATA_FAILURE,
    payload: {
        error
    }
});

const requestCardData = immCard => (dispatch) => {
    dispatch(requestCardDataRequest());

    const requestData = {
        query: {
            producto: immCard.getIn(['contract', 'product']),
            numeroContrato: immCard.getIn(['contract', 'number']),
            numeroTarjeta: immCard.get('number'),
            codigoSubtipo: immCard.get('productSubType'),
        }
    };

    return APIGet({
        dispatch,
        endpoint: 'cardData',
        url: apiURLBuilder.getURL('cardData'),
        params: requestData
    })
    .then(response => dispatch(requestCardDataSuccess(response)))
    .catch(error => dispatch(requestCardDataFailure(error)));
}

module.exports = {
    requestCardData,
}
